// Tiny CSV helper — quotes every field and escapes embedded quotes so values
// containing commas, quotes or newlines (e.g. guest notes) stay intact.
const escapeField = (value: unknown): string => {
  const s = value === null || value === undefined ? '' : String(value);
  return `"${s.replace(/"/g, '""')}"`;
};

export const toCsv = (headers: string[], rows: (string | number | boolean | null | undefined)[][]): string => {
  const lines = [headers, ...rows].map(row => row.map(escapeField).join(','));
  // Prepend a BOM so Excel opens UTF-8 correctly.
  return '﻿' + lines.join('\r\n');
};

export const downloadCsv = (
  filename: string,
  headers: string[],
  rows: (string | number | boolean | null | undefined)[][]
): void => {
  const csv = toCsv(headers, rows);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
